import React, { Component } from 'react';
import { withOktaAuth } from '@okta/okta-react';
import { Link } from 'react-router-dom';
import config from './config';

const maxTitleChars = 50;
const defaultImage = "data:image/png;base64,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";
//ZF9986@ENSEMBLE.INFRA.COM

export default withOktaAuth(class OrganizationalChart extends Component {

    constructor() {
        super();
        this.state = {
            isAuthenticated: false,
            ready: false,
            userProfile: {},
            selectedManagerIdx: 0,
            managers: []
        };
        this.accessToken = '';
    }

    async componentDidMount() {
        this.accessToken = this.props.authState.accessToken.accessToken;
        let userprofile = await this.getUserProfile();
        let manager = await this.getManager(userprofile.C_distinguishedName);
        this.setState({ ready: true, userProfile: userprofile, managers: manager.managers, selectedManagerIdx: manager.selectedManagerIdx, isAuthenticated: this.props.authState?.isAuthenticated }, () => {
            this.getPhoto();
        });
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevProps?.authState && this.props?.authState && prevProps.authState.isAuthenticated !== this.props.authState.isAuthenticated) {
            this.setState({ isAuthenticated: this.props.authState?.isAuthenticated });
        }
    }

    async getUserProfile() {
        try {
            let searchstring = this.props.location.search.replace("?", "");
            const response = await fetch(config.env.resourceServer.getOktaProfileUrl + "?userId=" + (searchstring ? searchstring : this.state.userinfo.preferred_username), {
                headers: {
                    Authorization: `Bearer ${this.accessToken}`
                },
            });

            if (response.status !== 200) {
                return;
            }

            const data = await response.json();
            return data;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    async getManager(selectedDN) {
        try {
            let manager = {
                manager: selectedDN
            };
            let managers = [];
            let response = {};

            while (manager.manager) {
                try {
                    let escapedManager = manager.manager.replace("\\", "\\\\");
                    escapedManager = encodeURI(escapedManager);
                    response = await fetch(`${config.env.resourceServer.getManager}?manager=${escapedManager}`, {
                        headers: {
                            Authorization: `Bearer ${this.accessToken}`
                        },
                    });

                    if (response.status !== 200) {
                        manager = {};
                        return;
                    }
                    manager = await response.json();
                    managers.splice(0, 0, manager);

                } catch (error) {
                    manager = {};
                    console.log(error);
                }
            }
            return { managers: managers, selectedManagerIdx: managers.length - 1 }
        } catch (err) {
            console.log(err);
            console.log('err');
        }
        return null;
    }

    async getPhoto() {
        try {
            var size = "240x240";
            this.state.managers.forEach((manager, i) => {
                try {
                    fetch(`${config.env.resourceServer.getOktaUserPhotoUrl}?userId=${manager.login}&size=${size}`, {
                        headers: {
                            Authorization: `Bearer ${this.accessToken}`
                        },
                    }).then(async response => {
                        if (response.status !== 200) {
                            manager.photo = defaultImage;
                            return;
                        }

                        let data = await response.json();
                        manager.photo = data.image ? data.image : defaultImage;
                        this.setState({ managers: this.state.managers }, () => {
                            if (this.state.selectedManagerIdx !== i) {
                                return;
                            }
                            manager.collaborators.forEach((collaborator) => {
                                fetch(`${config.env.resourceServer.getOktaUserPhotoUrl}?userId=${collaborator.login}&size=${size}`, {
                                    headers: {
                                        Authorization: `Bearer ${this.accessToken}`
                                    },
                                }).then(async response => {
                                    if (response.status !== 200) {
                                        collaborator.photo = defaultImage;
                                        return;
                                    }

                                    let data = await response.json();
                                    collaborator.photo = data.image;
                                    this.setState({ managers: this.state.managers });
                                });
                            });
                        });
                    });
                } catch (error) {
                    console.error(error);
                }
            });
        } catch (err) {
            console.error(err);
        }
    }

    async changeLevel(direction, idx) {
        if (this.changingLvl) {
            return;
        }
        this.changingLvl = true;
        if (direction === 'top') {
            let managers = this.state.managers.slice(0, idx + 1);
            this.setState({ managers: managers, selectedManagerIdx: idx }, () => {
                this.getPhoto();
            });
        } else {
            try {
                let managers = this.state.managers;
                let escapedManager = this.state.managers[this.state.selectedManagerIdx].collaborators[idx].C_distinguishedName.replace("\\", "\\\\");
                escapedManager = encodeURI(escapedManager);
                let response = await fetch(`${config.env.resourceServer.getManager}?manager=${escapedManager}`, {
                    headers: {
                        Authorization: `Bearer ${this.accessToken}`
                    },
                });

                if (response.status !== 200) {
                    return;
                }

                let manager = await response.json();
                managers.push(manager);

                this.setState({ managers: managers, selectedManagerIdx: this.state.selectedManagerIdx + 1 }, () => {
                    this.getPhoto();
                });
            } catch (error) {
                console.log(error);
            }
        }
        this.changingLvl = false;
    }

    render() {
        return (
            <div>
                {!this.state.ready && <div className="probootstrap-loader"></div>}
                {this.state.ready && !this.state.failed && this.state.isAuthenticated &&
                    <div>
                        <section className="probootstrap-slider flexslider2 page-inner">
                            <div className="overlay engiegradient-background"></div>
                            <div className="probootstrap-wrap-banner">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-md-8">
                                            <div className="page-title">
                                                <div className="probootstrap-breadcrumbs">
                                                    <a href="/">Home</a><span>OrgChart</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="probootstrap-section probootstrap-section-lighter">
                            <div className="container" id="main-wrapper">
                                <div className="org-header"></div>
                                {this.state.managers.map((manager, i) => {
                                    return <div key={i} className="org-row-g">
                                        <div className="org-row">
                                            <div className="org-item">
                                                <div className="org-card">
                                                    <div className="probootstrap-customresultlink probootstrap-card probootstrap-listing" onClick={() => this.changeLevel('top', i)}>
                                                        <Link to={'/Profile?' + manager.login} className="org-contact-link">
                                                            <i className="ms-Icon ms-Icon--Contact" aria-hidden="true"></i>
                                                        </Link>
                                                        <div className="probootstrap-card probootstrap-person">
                                                            <div className="probootstrap-card-media">
                                                                <img id={manager.login} src={manager.photo ? manager.photo : "img/default_profile_photo.png"} className="img-responsive" alt="Free HTML5 Template by uicookies.com" />
                                                            </div>
                                                            <div className="probootstrap-card-text">
                                                                <h2 className="probootstrap-card-heading mb0">{manager.firstName} {manager.lastName}</h2>
                                                                <span className="engie-blue">{manager.title ? manager.title.toUpperCase().substring(0, maxTitleChars) : ''}</span>
                                                                <p><small>{manager.email}</small></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {manager.collaborators && manager.collaborators.length > 0 &&
                                                    <div className="org-arrow-btm"></div>
                                                }
                                            </div>
                                        </div>
                                    </div>;
                                })}
                                <div className="org-header"></div>
                                {this.state.managers.length > 0 && this.state.managers[this.state.selectedManagerIdx].collaborators && this.state.managers[this.state.selectedManagerIdx].collaborators.length > 0 &&
                                    <div className="org-row-g">
                                        <div className="org-header"></div>
                                        <div className="org-row">
                                            <div className="org-h-arrow">
                                                {this.state.managers[this.state.selectedManagerIdx].collaborators.map((element, j) => {
                                                    return <div key={'collad' + j} className="org-item">
                                                        <div className="org-card">
                                                            <div className="probootstrap-customresultlink probootstrap-card probootstrap-listing" onClick={() => this.changeLevel('bottom', j)}>
                                                                <Link to={'/Profile?' + element.login} className="org-contact-link">
                                                                    <i className="ms-Icon ms-Icon--Contact" aria-hidden="true"></i>
                                                                </Link>
                                                                <div className="probootstrap-card probootstrap-person">
                                                                    <div className="probootstrap-card-media">
                                                                        <img id={element.login} src={element.photo ? element.photo : "img/default_profile_photo.png"} className="img-responsive" alt="Free HTML5 Template by uicookies.com" />
                                                                    </div>
                                                                    <div className="probootstrap-card-text">
                                                                        <h2 className="probootstrap-card-heading mb0">{element.firstName} {element.lastName}</h2>
                                                                        <span className="engie-blue">{element.title ? element.title.toUpperCase().substring(0, maxTitleChars) : ''}</span>
                                                                        <p><small>{element.email}</small></p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>;
                                                })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </section>
                    </div>
                }
            </div>
        )
    }
});